import script from "./TravelUpdates.vue?vue&type=script&setup=true&lang=ts"
export * from "./TravelUpdates.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__